import { produce } from 'immer'
import Actions from '../actions'

const initialState = {
  isSaveApplicationLoading: false,
  applicationId: null,
  subsribedToWaitingListSucceded: false,
  isConsentSigned: false,
  qualificationReasons: null,
  isFlowCompleted: false,
  welcomeBackError: null,
  deeplinkForSignup: null,
  paymentLink: null,
  isShareApplicationLoading: false
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.APPLICATION_INIT_REQUESTED:
      draft.isFlowCompleted = false
    // eslint-disable-next-line no-fallthrough
    case Actions.SAVE_PROGRESS_REQUESTED: {
      draft.isSaveApplicationLoading = true
      break
    }
    case Actions.SAVE_PROGRESS_RECEIVED: {
      draft.isSaveApplicationLoading = false
      break
    }
    case Actions.STEP_SAVED: {
      draft.deeplinkForSignup = payload.data?.deeplink
      draft.paymentLink = payload.data?.payment_link
      break
    }
    case Actions.APPLICATION_INIT_RECEIVED: {
      draft.applicationId = payload.applicationId
      draft.isSaveApplicationLoading = false
      break
    }
    case Actions.APPLICATION_DATA_REQUESTED: {
      draft.isSaveApplicationLoading = true
      break
    }
    case Actions.APPLICATION_DATA_RECEIVED: {
      draft.isSaveApplicationLoading = false
      draft.applicationId = payload.data.hashed_id

      break
    }
    case Actions.AUTO_FILL_APPLICATION: {
      draft.applicationId = payload.applicationId
      break
    }
    case Actions.OPERATION_FAILED: {
      draft.isSaveApplicationLoading = false
      draft.subsribedToWaitingListSucceded = false
      break
    }
    case Actions.SUBSCRIBE_TO_STATE_WAITING_LIST_REQUESTED: {
      draft.subsribedToWaitingListSucceded = false
      break
    }
    case Actions.SUBSCRIBE_TO_ENROLLMENT_REASON_WAITING_LIST_REQUESTED: {
      draft.subsribedToWaitingListSucceded = false
      break
    }
    case Actions.SUBSCRIBE_TO_WAITING_LIST_RECEIVED: {
      draft.subsribedToWaitingListSucceded = true
      break
    }
    case Actions.STEP_COMPLETED: {
      draft.isConsentSigned = payload?.isConsentSigned
      break
    }
    case Actions.APPLICATION_ID_REMOVED: {
      draft.applicationId = null
      draft.isFlowCompleted = true
      break
    }
    case Actions.QUALIFICATION_REASONS_RECEIVED: {
      draft.qualificationReasons = payload?.reasons
      break
    }
    case Actions.WELCOME_BACK_FAILED: {
      draft.welcomeBackError = payload?.error
      break
    }
    case Actions.SHARE_APPLICATION_REQUESTED: {
      draft.isShareApplicationLoading = true
      break
    }
    case Actions.SHARE_APPLICATION_RECEIVED: {
      draft.isShareApplicationLoading = false
      break
    }
    case Actions.LOGOUT_RECEIVED: {
      return initialState
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
